/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1AccesscontrolRolesQueryResponse,
  GetApiV1AccesscontrolRoles401,
  GetApiV1AccesscontrolRoles500,
} from "../../types/accessControlUsersController/GetApiV1AccesscontrolRoles.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1AccesscontrolRoles } from "../../clients/accessControlUsersController/getApiV1AccesscontrolRoles.ts";

export const getApiV1AccesscontrolRolesQueryKey = () =>
  [{ url: "/api/v1/accesscontrol/roles" }] as const;

export type GetApiV1AccesscontrolRolesQueryKey = ReturnType<
  typeof getApiV1AccesscontrolRolesQueryKey
>;

export function getApiV1AccesscontrolRolesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1AccesscontrolRolesQueryKey();
  return queryOptions<
    GetApiV1AccesscontrolRolesQueryResponse,
    ResponseErrorConfig<
      GetApiV1AccesscontrolRoles401 | GetApiV1AccesscontrolRoles500
    >,
    GetApiV1AccesscontrolRolesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1AccesscontrolRoles({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os valores do enum EUserRole com id e nome. **(Requer Authorization para autenticação)**
 * @summary Buscar todos os roles (Requer Authorization para autenticação)
 * {@link /api/v1/accesscontrol/roles}
 */
export function useGetApiV1AccesscontrolRoles<
  TData = GetApiV1AccesscontrolRolesQueryResponse,
  TQueryData = GetApiV1AccesscontrolRolesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1AccesscontrolRolesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1AccesscontrolRolesQueryResponse,
        ResponseErrorConfig<
          GetApiV1AccesscontrolRoles401 | GetApiV1AccesscontrolRoles500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1AccesscontrolRolesQueryKey();

  const query = useQuery(
    {
      ...getApiV1AccesscontrolRolesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1AccesscontrolRoles401 | GetApiV1AccesscontrolRoles500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
